<template>
  <div class="max-w-2xl mx-auto p-8 h-full flex flex-col">
    <slot />
  </div>
</template>
